<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONVÊNIO -
                            <strong
                                >{{ convenio.vcCodigoEstruturado }} -
                                {{
                                    convenio.convenente
                                        ? convenio.convenente
                                        : ''
                                }}</strong
                            >
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Cadastrais" active class="pb-0">
                                <Dados-Cadastrais
                                    :convenio="convenio"
                                ></Dados-Cadastrais>
                            </b-tab>
                            <b-tab title="Prestação de Contas" class="pb-0" v-if="$temAcesso('GESCON-FORN-CONV-02')">
                                <Prestacao-Mensal
                                    :convenio="convenio"
                                ></Prestacao-Mensal>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import ConveniosServicos from '../ConvenioServicos'
    import DadosCadastrais from './ConvenioDadosCadastrais'
    import PrestacaoMensal from './ConvenioPrestacaoContasMensal'

    export default {
        components: {
            DadosCadastrais,
            PrestacaoMensal
        },

        data() {
            return {
                convenio: {},
                //dadosRm: {},
                operacao: 'DETALHAR',
                tabIndex: 0,
                erros: []
            }
        },

        methods: {
            voltar() {
                this.$router.push({ name: 'GesconConvenios' })
            },

            obterConvenio() {
                this.$store.dispatch('addRequest')
                ConveniosServicos.ObterConvenioPorId(this.$route.params.idConvenio).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.convenio = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            },
        },

        created() {
            this.obterConvenio()
         },
    }
</script>
